export default __webpack_public_path__ + "static/dream3-c77644385c46164df8dedb16f1d5058c.png";